import moment from 'moment'
import DatePicker from "react-datepicker";
require("utility/date-pickers/month_picker.scss");

class MonthPicker extends React.Component {
    constructor(props) {
        super();
        autobind(this);
        this.state = { 
            startDate: props.startDate || moment().startOf('month').toDate(),
            endDate: props.endDate || moment().endOf('month').toDate(),
            selectedDate: props.selectedDate || null
        };
    }

    onChange(selectedDate) {
        var startDate = moment(selectedDate, "YYYY-MM-DD").startOf('month').toDate()
        var endDate = moment(selectedDate, "YYYY-MM-DD").endOf('month').toDate()
        this.setState({ selectedDate, endDate, startDate })
        if (this.props.onChange) {
            this.props.onChange(startDate, endDate, selectedDate)
        }
    }

    isSameMonth(date1, date2) {
        var moment1 = moment(date1);
        var moment2 = moment(date2);
        return moment1.month() === moment2.month() && moment1.year() === moment2.year();
    }

    render() {
        var { selectedDate } = this.state
        
        return (
            <div className='monthPickerContainer'>
                <DatePicker className="form-control"
                    dateFormat="MM/yyyy"
                    selected={selectedDate ? moment(selectedDate) : null}
                    onChange={(date) => this.onChange(date.format("YYYY-MM-DD"))}
                    dayClassName={(date) =>
                        this.isSameMonth(date, selectedDate) ? "react-datepicker__day--selected" : ''
                    }
                    dateFormatCalendar={"MMM yyyy"}
                    showYearDropdown
                />	
            </div>
        );
    }
}

module.exports = MonthPicker;


// WEBPACK FOOTER //
// ./modules/components/utility/date-pickers/MonthPicker.js